import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Money } from "@faire/web/ui/Money";
import React from "react";

export const BrandMinimumInfo: React.FC<{
  brand_first_order_minimum: IFaireMoney | undefined;
  brand_reorder_minimum: IFaireMoney | undefined;
}> = ({ brand_first_order_minimum, brand_reorder_minimum }) => {
  if (
    brand_first_order_minimum !== undefined &&
    brand_reorder_minimum !== undefined &&
    brand_first_order_minimum.amount_cents !==
      brand_reorder_minimum.amount_cents
  ) {
    return (
      <StrictLocalMsg
        defaultMessage="{brandMinimum} Min | {brandReorderMinimum} Reorder Min"
        description={{
          text: "a brand's minimum order amount and minimum reorder amount.",
        }}
        values={DEPRECATED_backwardsCompatibleValues({
          brandMinimum: (
            <Money omitCentsIfZero money={brand_first_order_minimum} />
          ),
          brandReorderMinimum: (
            <Money omitCentsIfZero money={brand_reorder_minimum} />
          ),
        })}
      />
    );
  }

  if (
    brand_first_order_minimum?.amount_cents ===
      brand_reorder_minimum?.amount_cents &&
    brand_first_order_minimum?.amount_cents === 0
  ) {
    return (
      <StrictLocalMsg
        defaultMessage="No Minimum"
        description={{ text: "Brand has no minimum order amount" }}
      />
    );
  }

  if (
    brand_first_order_minimum !== undefined ||
    brand_reorder_minimum !== undefined
  ) {
    return (
      <StrictLocalMsg
        defaultMessage="{brandMinimum} Minimum"
        description={{
          text: "a brand's minimum order amount.",
        }}
        values={DEPRECATED_backwardsCompatibleValues({
          brandMinimum: (
            <Money
              omitCentsIfZero
              money={(brand_first_order_minimum || brand_reorder_minimum)!}
            />
          ),
        })}
      />
    );
  }

  return null;
};
